
(function () {

    // Translating

    var lang = document.documentElement.lang;

    var fr = {
        tClose: 'Fermer (Esc)', // Alt text on close button
        tLoading: 'Chargement...', // Text that is displayed during loading. Can contain %curr% and %total% keys
        gallery: {
            tPrev: 'Précédent (Flèche gauche)', // Alt text on left arrow
            tNext: 'Prochain (Flèche droite)', // Alt text on right arrow
            tCounter: '%curr% de %total%' // Markup for "1 of 7" counter
        },
        image: {
            tError: '<a href="%url%">L\'image</a> n\'a pas pu être chargée..' // Error message when image could not be loaded
        },
        ajax: {
            tError: '<a href="%url%">Le contenu</a> n\'a pas pu être chargé.' // Error message when ajax request failed
        }
    };

    var en = {
        tClose: 'Close (Esc)', // Alt text on close button
        tLoading: 'Loading...', // Text that is displayed during loading. Can contain %curr% and %total% keys
        gallery: {
            tPrev: 'Previous (Left arrow key)', // Alt text on left arrow
            tNext: 'Next (Right arrow key)', // Alt text on right arrow
            tCounter: '%curr% of %total%' // Markup for "1 of 7" counter
        },
        image: {
            tError: '<a href="%url%">The image</a> could not be loaded.' // Error message when image could not be loaded
        },
        ajax: {
            tError: '<a href="%url%">The content</a> could not be loaded.' // Error message when ajax request failed
        }
    };

    $.extend(true, $.magnificPopup.defaults, lang === 'fr' ? fr : en );

    $(document).ready(function() {
        $('[popup-gallery]').magnificPopup({
            delegate: 'a',
            type: 'image',
            mainClass: 'mfp-img-mobile',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1] // Will preload 0 - before current, and 1 after the current image
            }
        });
    });
}( require('magnific-popup') ));
